import { createSlice } from "@reduxjs/toolkit";
import { Document } from "types/Document";
import { explodeIndicatorId } from "utils/utils";
import { actions } from 'react-table';

interface DocumentsHistoriesSlice {
  documents: Document[];
  authors: string[];
  codes: string[];
  actions: string[];
}

const initialState: DocumentsHistoriesSlice = {
  documents: [],
  authors: [],
  codes: [],
  actions: [],
};

export const DocumentsHistoriesSlice = createSlice({
  name: "documents",
  initialState: initialState,
  reducers: {
    addDocumentsHistories: (state, action) => {
      state.documents = action.payload?.documents;
      const updaters : []  = action.payload?.documents.map((doc: any) => doc.lastUpdateBy);
      const codes = state.documents.map((doc) => doc.code);
      const actions : [] = action.payload?.documents.map((doc: any) => doc.action);

      state.authors = updaters.filter((v, i, a) => a.indexOf(v) === i);
      state.codes = codes.filter((v, i, a) => a.indexOf(v) === i);
      state.actions = actions.filter((v, i, a) => a.indexOf(v) === i);
    },
    resetDocumentsHistories: (state) => {
      state.documents = [];
      state.authors = [];
      state.codes = [];
    },
  },
});

export const {
  addDocumentsHistories, resetDocumentsHistories
} = DocumentsHistoriesSlice.actions;
export default DocumentsHistoriesSlice.reducer;
